module.exports = __webpack_public_path__ + "static/media/consultationPppRu.8b807c48.jpg";